/**
 * @generated SignedSource<<16892054e241485d8da16040d1deab05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileTokenDetails_nftItem$data = {
  readonly contract: {
    readonly name: string | null;
  } | null;
  readonly tokenId: string | null;
  readonly tokenUri: string | null;
  readonly " $fragmentType": "NftItemTileTokenDetails_nftItem";
};
export type NftItemTileTokenDetails_nftItem$key = {
  readonly " $data"?: NftItemTileTokenDetails_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTokenDetails_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileTokenDetails_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "a7c9c2d95fa4ae5c96ba468b25e2497e";

export default node;
